import { itemsPerPage } from 'lib/config'
import { useEventRegistrationsQuery } from 'graphql/generated'
import useToasts from 'hooks/useToasts'
import { parseGqlErrors } from 'hooks/useQueryErrorHandler'

function useEventAttendees(eventId: string, resultsPerPage = itemsPerPage) {
  const { addToast } = useToasts()

  const defaultVariables = {
    id: eventId,
    registrationConnection: {
      first: 0
    }
  }

  const { loading, data, networkStatus, refetch, fetchMore } =
    useEventRegistrationsQuery({
      notifyOnNetworkStatusChange: true,
      variables: {
        ...defaultVariables,
        registrationConnection: {
          first: resultsPerPage
        }
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
      skip: !eventId,
      onError: err => {
        const errors = Object.values(parseGqlErrors(err))
        addToast(
          errors && errors.length
            ? String(errors[0])
            : `Couldn't load attendees at the moment. Please try again later.`,
          {
            appearance: 'warning'
          }
        )
      }
    })

  const loadingMore = networkStatus === 3
  const refetching = networkStatus === 2 || networkStatus === 4

  const edges = data?.event.registrations.edges
  const pageInfo = data?.event.registrations.pageInfo

  const loadMore = () => {
    if (!pageInfo || !pageInfo.hasNextPage) {
      return
    } else if (loading || loadingMore) {
      return
    }

    fetchMore({
      variables: {
        ...defaultVariables,
        registrationConnection: {
          first: resultsPerPage,
          after: pageInfo.endCursor
        }
      }
    })
  }

  return {
    loading,
    loadingMore,
    refetching,
    networkStatus,
    refetch,
    loadMore,
    edges,
    pageInfo
  }
}

export default useEventAttendees
